// extracted by mini-css-extract-plugin
export default {"textInputContainer":"styles_textInputContainer__hulCP","label":"styles_label__2-h-+"};